import { ORG_SHORT_NAME } from "../../../util/appInfo";
import { EmbeddedHTML } from "../EmbeddedHTML/EmbeddedHTML";

const PrivacyPolicy = () => {
  let __html;
  let template;

  try {
    __html = require(
      `../../../assets/html/${ORG_SHORT_NAME.toLowerCase()}/privacy_policy`
    );
    template = { __html: __html };
  } catch {
    console.warn(
      "[PrivacyPolicy] You should provide the HTML code for",
      ORG_SHORT_NAME,
      "privacy policy"
    );
  }
  return <EmbeddedHTML html={template} />;
};

export { PrivacyPolicy };
